/* Aijency chat bubble — pin it to the *visible* bottom on mobile, in every
   Safari toolbar state, smoothly (the behaviour IKEA's floating widget has).

   A plain `position: fixed; bottom` element is anchored to the layout viewport,
   so when Safari's bottom bar shows/hides the bubble ends up behind the bar or
   floating with a gap. We instead position by `top`, derived straight from the
   visualViewport (offsetTop + height = the true visible bottom, in the same
   coordinate space as a fixed element's `top`). Updated on an animation frame,
   so it tracks smoothly without the CSS `dvh` staircase. Desktop is left to CSS. */
(function () {
  var BASE = 12;   // px above the visible bottom (matches the CSS fallback)
  var mq = window.matchMedia('(max-width: 768px)');
  var bubble = null;
  var scheduled = false;

  function apply() {
    scheduled = false;
    bubble = bubble || document.getElementById('aijency-bubble');
    if (!bubble) return;
    var st = bubble.style;

    if (!mq.matches) {                 // desktop → hand back to CSS
      st.removeProperty('top');
      st.removeProperty('bottom');
      return;
    }

    var vv = window.visualViewport;
    if (!vv) {                         // no API → CSS fallback (bottom: 12px)
      st.removeProperty('top');
      st.setProperty('bottom', BASE + 'px', 'important');
      return;
    }

    var h = bubble.offsetHeight || 50;             // bubble height (50px on mobile)
    var top = Math.round(vv.offsetTop + vv.height - h - BASE);
    st.setProperty('top', top + 'px', 'important');
    st.setProperty('bottom', 'auto', 'important');
  }

  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(apply); }
  }

  function bind() {
    schedule();
    var vv = window.visualViewport;
    if (vv) {
      vv.addEventListener('resize', schedule);
      vv.addEventListener('scroll', schedule);
    }
    window.addEventListener('resize', schedule);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    else if (mq.addListener) mq.addListener(schedule);
  }

  // The bubble is injected by the Aijency app after load — wait for it.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (document.getElementById('aijency-bubble')) {
      clearInterval(timer);
      bubble = document.getElementById('aijency-bubble');
      bind();
    } else if (tries > 60) {
      clearInterval(timer);
    }
  }, 500);
})();
